import React from 'react';
import { StarIcon, QuoteIcon } from 'lucide-react';
export function TestimonialsSection() {
  const testimonials = [{
    name: 'Laura Martínez',
    role: 'Nail Artist & Emprendedora',
    quote: 'Pasé de hacerle las uñas a mis amigas... a tener una agenda llena y cobrar precios premium. Esta masterclass fue mi punto de inflexión. Ya recuperé mi inversión en la primera semana.',
    image: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=922&q=80'
  }, {
    name: 'Daniela Romero',
    role: 'Estilista & Mamá Emprendedora',
    quote: 'Tenía miedo de empezar desde cero, pero el paso a paso me dio toda la seguridad. Hoy atiendo desde casa, con mis hijos cerca y clientas felices.',
    image: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=988&q=80'
  }, {
    name: 'Alejandra Torres',
    role: 'Ex recepcionista',
    quote: 'Nunca imaginé que podría ganar dinero haciendo algo tan bonito. Mi esposo no lo creía hasta que pagué el alquiler con mis ingresos de uñas.',
    image: 'https://images.unsplash.com/photo-1531746020798-e6953c6e8e04?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1964&q=80'
  }, {
    name: 'Mariana Gómez',
    role: 'Recién egresada',
    quote: 'Con esta formación, ya estoy cobrando el doble que mis compañeras que siguen trabajando en salones. Y lo hago desde mi casa.',
    image: 'https://images.unsplash.com/photo-1567532939604-b6b5b0db2604?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=774&q=80'
  }, {
    name: 'Sofía López',
    role: 'Diseñadora Freelance',
    quote: 'Aplicé las estrategias de redes sociales del bono y tripliqué mi audiencia. Ahora tengo lista de espera cada semana.',
    image: 'https://images.unsplash.com/photo-1554151228-14d9def656e4?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=986&q=80'
  }, {
    name: 'Karla Jiménez',
    role: 'Migrante en Europa',
    quote: 'Este curso me dio la posibilidad de emprender en otro país. Sin papeles, sin experiencia, pero con muchas ganas y una guía perfecta.',
    image: 'https://images.unsplash.com/photo-1592621385612-4d7129426394?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=987&q=80'
  }];
  return <section className="py-16 px-4" data-id="element-255">
      <div className="container mx-auto max-w-6xl" data-id="element-256">
        <div className="text-center mb-12" data-id="element-257">
          <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-258">
            Testimonios Reales
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-259">
            Mira lo que nuestras alumnas han logrado con Nail Masterclass Pro
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-260">
          {testimonials.map((testimonial, index) => <div key={index} className="bg-white p-6 rounded-xl shadow-md hover:shadow-lg transition-all border border-pink-100" data-id="element-261">
              <div className="flex items-center mb-4" data-id="element-262">
                <img src={testimonial.image} alt={testimonial.name} className="w-12 h-12 rounded-full object-cover mr-3" data-id="element-263" />
                <div data-id="element-264">
                  <h3 className="font-semibold" data-id="element-265">{testimonial.name}</h3>
                  <p className="text-sm text-pink-500" data-id="element-266">{testimonial.role}</p>
                </div>
              </div>
              <div className="mb-4" data-id="element-267">
                <div className="flex text-yellow-400" data-id="element-268">
                  <StarIcon className="h-4 w-4 fill-current" data-id="element-269" />
                  <StarIcon className="h-4 w-4 fill-current" data-id="element-270" />
                  <StarIcon className="h-4 w-4 fill-current" data-id="element-271" />
                  <StarIcon className="h-4 w-4 fill-current" data-id="element-272" />
                  <StarIcon className="h-4 w-4 fill-current" data-id="element-273" />
                </div>
              </div>
              <div className="relative" data-id="element-274">
                <QuoteIcon className="h-8 w-8 text-pink-100 absolute -top-2 -left-2" data-id="element-275" />
                <p className="text-gray-700 relative z-10 pl-4" data-id="element-276">
                  "{testimonial.quote}"
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}